export default __webpack_public_path__ + "static/media/Eran Spahbed Lock.6d8bd66b.jpg";